<template>
  <messages-table :url="url" :params="params"></messages-table>
</template>

<script>
import MessagesTable from './messages/table';

export default {
  components: {
    MessagesTable,
  },

  props: {
    url: String,
    params: Object,
  },
}
</script>

<style scoped>

</style>
